const AmyAspectRatio = {
  Rect_16x9: 1.78,
  Square: 1.0,
  Rect_2x1: 2.0,
};

export default AmyAspectRatio;
